// Per-device memory only: the families this browser has opened (name + last member).
// Nothing here is shared, and no family list ships in the app.
const FAMILIES_KEY = 'giftTracker.families';
const LEGACY_KEY = 'giftTracker.last'; // v2.0.x: { code, member }

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(key)) || {};
  } catch {
    return {};
  }
}

function writeFamilies(families) {
  try {
    localStorage.setItem(FAMILIES_KEY, JSON.stringify(families));
  } catch {
    /* storage unavailable; ignore */
  }
}

export function readFamilies() {
  return read(FAMILIES_KEY);
}

export function rememberFamily(code, patch) {
  const families = readFamilies();
  families[code] = { ...families[code], ...patch };
  writeFamilies(families);
}

export function forgetFamily(code) {
  const families = readFamilies();
  delete families[code];
  writeFamilies(families);
}

export function lastMemberFor(code) {
  const legacy = read(LEGACY_KEY);
  return readFamilies()[code]?.member || (legacy.code === code ? legacy.member : '') || '';
}
